import { Alert, Box } from '@chakra-ui/react';
import { ReactNode } from 'react';

interface AlertErrorProps {
  title: string;
  message: string;
  children?: ReactNode;
}

export default function AlertError({ title, message, children }: AlertErrorProps) {
  return (
    <Alert.Root status="warning" variant="subtle" bg="yellow.50" borderRadius="md" p={4}>
      <Alert.Content ml={2}>
        <Alert.Title fontSize="sm" fontWeight="medium" color="yellow.800">
          {title}
        </Alert.Title>
        <Alert.Description mt={2} fontSize="sm" color="yellow.700">
          <pre style={{ whiteSpace: 'pre-wrap' }}>{message}</pre>
        </Alert.Description>
        {children && <Box pt={2}>{children}</Box>}
      </Alert.Content>
    </Alert.Root>
  );
}
